import { render, staticRenderFns } from "./OrganisationDetail.vue?vue&type=template&id=1affcab0&scoped=true&"
import script from "./OrganisationDetail.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDetail.vue?vue&type=style&index=0&id=1affcab0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1affcab0",
  null
  
)

export default component.exports